import React from "react";
import heroImg from "../../images/use-case/sub-use-case-hero.png";

const IndustriesHero = () => {
  return (
    <section className="w-full bg-[#1B5E4B] text-white py-12 sm:py-16 lg:py-20">
      <div className="max-w-8xl mx-auto px-8 sm:px-12 md:px-16 lg:px-24 xl:px-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* Left Column */}
          <div className="lg:col-span-6 flex flex-col justify-center" data-aos="fade-right">
            <span className="text-[#48C59A] text-xs sm:text-sm font-bold tracking-widest uppercase mb-3">
              INDUSTRIES WE SERVE
            </span>
            <h1 className="text-4xl sm:text-5xl lg:text-[52px] font-extrabold text-white tracking-tight leading-[1.15] font-['Axiforma',sans-serif]">
              Where Language <br className="hidden sm:inline" />
              Meets Every Industry
            </h1>
            <p className="text-emerald-100/85 text-base sm:text-lg leading-relaxed mt-5 max-w-xl font-normal">
              No matter your sector, clear communication drives results. NKENNEAi helps you connect with users, customers, and communities in the languages they understand best.
            </p>
          </div>

          {/* Right Column */}
          <div className="lg:col-span-6 flex items-center justify-center" data-aos="fade-left">
            <div className="w-full rounded-[24px] sm:rounded-[32px] overflow-hidden shadow-2xl bg-white/5 border border-white/10">
              <img
                src={heroImg}
                alt="Where Language Meets Every Industry"
                className="w-full h-auto object-cover max-h-[440px]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesHero;
